import {TaskServizi} from "@commons/mapping/TaskServizi";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export interface CalcoloPresenzeTask extends TaskServizi {

    elaboraGiorniBloccati: boolean,
    elaboraGiorniBloccatiSeWF: boolean,
    livelloPresenzeChiusura: number; // Livello presenze chiusura dell'utente che sta eseguendo la giustificazione di massa!

    soloStandard: boolean,
    impostaPrevistoConESenza: boolean, // FORZA modalità standard (utile per calcolo pianificazione)

}

export class CalcoloPresenzeTask extends TaskServizi {

    static factory: ObjectFactory<CalcoloPresenzeTask> = (json?) => {
        const task = merge<CalcoloPresenzeTask, Partial<CalcoloPresenzeTask> | undefined>({
            // da TaskServizi
            idAziendaMaster: 0,
            idAzienda: 0,
            anno: 0,
            mese: 0,
            ggIniziale: null,
            ggFinale: null,
            eseguiPer: 'TUTTI',
            idDipSingolo: null,
            agenziaInterinale: null,
            spaccatura: 'NESSUNA',
            codiceCDIC: null,
            dataIniziale: null,
            dataFinale: null,
            result: null,
            stato: 'IN_ATTESA',

            elaboraGiorniBloccati: false,
            elaboraGiorniBloccatiSeWF: false,
            livelloPresenzeChiusura: 0,

            soloStandard: false,
            impostaPrevistoConESenza: false,

            URI: null,
        }, json);

        return TaskServizi.normalizza(task) as CalcoloPresenzeTask;
    }
}